// Supply-chain overlay — port + AIS shipping disruptions as MIL-STD-2525
// neutral frames (oval) tinted by severity.

import type { intel as i } from '@eidollon/contracts';
import { buildIconLayer } from './_icon-builder.js';
import { withGeom } from './_shared.js';
import type { LayerSpec } from './registry.js';

const TYPES: readonly i.SignalType[] = ['SUP'];
const TYPE_SET = new Set<i.SignalType>(TYPES);

export const supplyLayer: LayerSpec = {
  id: 'supply',
  label: 'SUP · supply',
  kind: 'icon',
  signalTypes: TYPES,
  color: 'var(--magenta)',
  colorAxis: 'category',
  description: 'Maritime chokepoints + supply chain disruptions',
  classification: 'OPEN',
  legend: {
    swatch: 'var(--magenta)',
    label: 'SUP',
    hint: 'Port + AIS shipping disruptions',
  },
  select: (rows) => withGeom(rows).filter((r) => TYPE_SET.has(r.signal_type)),
  // Always visible — the feed is capped at ~200 rows so there is no clutter,
  // and a single-type filter must show that type at ANY zoom (otherwise the
  // map goes empty below the old threshold). See route bug: "toggle on -> disappear".
  visibleAtZoom: () => true,
  deckLayer: ({ rows, viewport, onPick }) => {
    const data = withGeom(rows).filter((r) => TYPE_SET.has(r.signal_type));
    return buildIconLayer({
      id: 'intel-supply',
      rows: data,
      zoom: viewport.zoom,
      sizeMin: 11,
      sizeMax: 26,
      onPick,
    });
  },
};
